import { useEffect } from 'react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';

import { sendSentryError } from '@frontend/utils/sendSentryError';

import FullScreenLoader from './FullScreenLoader';

const RequireAuthOnly = ({ children }: { children: JSX.Element }): JSX.Element => {
  const { authState, oktaAuth } = useOktaAuth();

  useEffect(() => {
    const login = async () => {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      oktaAuth.setOriginalUri(originalUri);
      await oktaAuth.signInWithRedirect();
    };

    if (!authState) {
      return;
    }
    if (!authState.isAuthenticated) {
      login().catch(sendSentryError);
    }
  }, [authState, oktaAuth, authState?.isAuthenticated]);

  if (!authState || !authState.isAuthenticated) {
    return <FullScreenLoader />;
  }

  return children;
};

export default RequireAuthOnly;
